import { Controller } from "@hotwired/stimulus"

// Live-updates a multi-select dropdown's summary label as its boxes are ticked, BEFORE Apply — the server
// renders the applied selection, this previews the pending one. Mirrors the server's collapse rule:
//   - all boxes ticked  → allLabel  (default "all")
//   - no boxes ticked   → emptyLabel (per-control: a score filter means "all"; a status filter falls back
//                          to its default group, e.g. "awaiting")
//   - a subset          → the picked values in DOM (display) order
export default class extends Controller {
  static targets = ["summary", "checkbox"]
  static values = { emptyLabel: { type: String, default: "all" }, allLabel: { type: String, default: "all" } }

  update() {
    const checked = this.checkboxTargets.filter((box) => box.checked).map((box) => box.value)
    let label
    if (checked.length === 0) label = this.emptyLabelValue
    else if (checked.length === this.checkboxTargets.length) label = this.allLabelValue
    else label = checked.join(", ")
    this.summaryTarget.textContent = label
  }
}
